import React from 'react';
import { Search } from 'lucide-react';

export default function SearchBar({ value, onChange, placeholder }) {
  return (
    <div className="flex-1 relative flex items-center border border-locate2-border rounded-lg focus-within:border-locate2-primary focus-within:ring-1 focus-within:ring-locate2-primary">
      <Search
        size={20}
        className="absolute left-3 text-locate2-light-gray pointer-events-none"
      />
      <input
        type="text"
        placeholder={placeholder || 'Search...'}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full pl-10 pr-4 py-2.5 bg-transparent text-locate2-medium-gray placeholder:text-locate2-light-gray focus:outline-none"
      />
    </div>
  );
}
